var t = /* @__PURE__ */ ((e) => (e[e.MALE = 0] = "MALE", e[e.FEMALE = 1] = "FEMALE", e[e.OTHER = 2] = "OTHER", e))(t || {});
const o = {
  intro: "0",
  addPeopleToSession: "1",
  connectCalendar: "2",
  watchDemo: "3",
  tryMeetingMemory: "4",
  noteTaker: "5",
  features: "6"
}, a = Object.values(o), n = [
  o.noteTaker,
  o.tryMeetingMemory
];
export {
  t as Gender,
  o as userOnboarding,
  n as userOnboardingChecklistValues,
  a as userOnboardingValues
};
